import React, { useState, useEffect } from 'react';
import OrderMap from './OrderMap';

function ActiveOrderCard({ order, driverLocation, onDriverAction, getOrderStatusColor, formatCurrency }) {
  const [timeLeft, setTimeLeft] = useState(20);

  useEffect(() => {
    setTimeLeft(20);
  }, [order?.id]);

  useEffect(() => {
    if (!order || order.status !== 'ready') return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          onDriverAction('rejected', order.id);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [order?.id]);

  if (!order) return null;

  const openNavigation = () => {
    if (!order.delivery_lat || !order.delivery_lng) return;

    const lat = order.delivery_lat;
    const lng = order.delivery_lng;
    const url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&travelmode=driving`;
    window.open(url, '_blank');
  };

  return (
    <div className="active-order-card">
      <div className="new-order-banner">🚨 NUEVO PEDIDO</div>

      <div className="active-order-header">
        <h2 className="active-order-title">📦 Pedido #{order.order_code}</h2>
        <span className="order-status-badge" style={{ backgroundColor: getOrderStatusColor(order.status) }}>
          {order.status}
        </span>
      </div>

      {order.branch_name && (
        <p className="order-restaurant">🍔 {order.branch_name}</p>
      )}

      <div className="active-order-info">
        {(order.restaurant_name || order.branch_address || order.branch_name) && (
          <div className="active-order-row">
            <span className="active-order-icon">🍔</span>
            <div>
              <p className="active-order-label">Restaurante cercano</p>
              <p className="active-order-value">
                {order.restaurant_name || order.branch_name || 'Restaurante'}
                {order.branch_address && ` · ${order.branch_address}`}
              </p>
            </div>
          </div>
        )}

        <div className="active-order-row">
          <span className="active-order-icon">📍</span>
          <div>
            <p className="active-order-value">{order.delivery_address}</p>
          </div>
        </div>

        {order.distance_to_restaurant_km != null && (
          <div className="active-order-row">
            <span className="active-order-icon">🚗</span>
            <div>
              <p className="active-order-value">{order.distance_to_restaurant_km} km al restaurante</p>
            </div>
          </div>
        )}
      </div>

      {order.delivery_lat && order.delivery_lng && (
        <>
          <OrderMap order={order} driverLocation={driverLocation} />
          <button className="action-btn navigate-btn" onClick={openNavigation}>
            🧭 Navegar con Google Maps
          </button>
        </>
      )}

      {order.total_cents && (
        <div className="active-order-total">
          <span>Total: {formatCurrency(order.total_cents)}</span>
        </div>
      )}

      <div className="active-order-actions">
        {(order.status === 'ready' || order.is_available) && (
          <button
            onClick={() => onDriverAction('accepted', order.id)}
            className="action-btn accept-btn"
          >
            ✅ Aceptar Pedido ({timeLeft})
          </button>
        )}
        {order.status === 'in_route' && (
          <div className="active-order-buttons-row">
            <button
              onClick={() => onDriverAction('picked_up', order.id)}
              className="btn-pickup"
            >
              📦 Marcar Recogido
            </button>
            <button
              onClick={() => onDriverAction('delivered', order.id)}
              className="btn-deliver"
            >
              ✅ Marcar Entregado
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ActiveOrderCard;
